export default "/assets/search-f98fb5a656118d8d325676c99a07c458d85e041305ec6203fd621285379c078e.svg";